var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-layers',{attrs:{"fixed-width":""}},[_c('font-awesome-icon',{attrs:{"icon":"clipboard","size":_vm.size}}),_c('font-awesome-icon',{attrs:{"icon":"wrench","size":_vm.size,"inverse":"","transform":"shrink-10 down-2"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }